module.exports = __webpack_public_path__ + "assets/images/img2x-196de14d579ee119402c13cffef6ebeb.png";